<template>
  <div class="channel-container">
    <span class="title-label">{{ $t(`${i18nPrefix}.label.postTo`) }}</span>
    <div class="channel-list">
      <div v-if="isProcessing" class="processing-message">{{ $t(`${i18nPrefix}.message.channelPostProcessing`) }}</div>
      <div
        class="list-item"
        v-for="(item, index) in channelList"
        :key="index"
        :class="[item.newStatus || item.originStatus]"
      >
        <div class="channel-icon">
          <i class="iconfont" :class="[CHANNEL_ICON_MAPPING[`channel_${item.key}`]]"/>
          <i :class="['open-icon', item.newStatus || item.originStatus]"></i>
          <el-dropdown class="dropdown-container" trigger="click" placement="bottom-start" :disabled="!hasJobEditPermission || item.isPending" @command="handelChangeChannelPostStatus($event, item)">
            <span class="operate-icon iconfont icona-xingzhuangbeifen8"></span>
            <el-dropdown-menu class="channel-operation-container" slot="dropdown">
              <el-dropdown-item
                v-for="option in getOptionListByStatus(item)"
                :key="`${item.key}_${index}_${option.label}`"
                :command="option.action"
              >
                {{ option.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span class="channel-name">{{ item.i18nName }}</span>
      </div>
    </div>
    <span class="tips" v-html="$t(`${i18nPrefix}.message.notFoundPostingChannel`)"></span>
    <div class="button-container">
      <el-button class="button" type="primary" :disabled="isProcessing || !hasChangeChannel" @click="handelPublishChannel">{{ $t(`${i18nPrefix}.btn.publish`) }}</el-button>
    </div>
    <RectLoading class="channel-loading" v-show="loading"/>
  </div>
</template>

<script>
import { channelDefaultCountForLinkedin } from '@/constant/company'
import _ from 'lodash'
import RectLoading from '@/components/loading/rectLoading'
import {
  CHANNEL_OPERATION_ADD, CHANNEL_OPERATION_HIDE, CHANNEL_OPERATION_UPDATE, CHANNEL_OPERATION_CANCEL,
  CHANNEL_OPERATION_PUBLISH, CHANNEL_OPERATION_VIEW, CHANNEL_ICON_MAPPING, DEFAULT_CHANNEL_ID,
  CHANNEL_OPERATION_MANUAL_ADD
} from '@/constant/job'

export default {
  components: {
    RectLoading
  },
  props: {
    postingChannels: {
      default: []
    },
    isProcessing: {
      default: false
    },
    channelList: {
      required: true,
      type: Array
    },
    loading: {
      default: false
    }
  },
  data () {
    return {
      checkList: [],
      i18nPrefix: 'admin.job.list',
      CHANNEL_ICON_MAPPING,
      dialog: {
        show: true

      }
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    hasJobEditPermission () {
      return this.hasAnyPermission('PERM_JOB_EDIT')
    },
    hasChangeChannel () {
      let result = false
      _.forEach(this.channelList, (channel) => {
        if (channel.newStatus !== '' && channel.newStatus !== channel.originStatus) {
          result = true
        }
      })
      return result
    },
    manualJobPostingUsedChanelIds () {
      return _.chain(this.channelList).filter(channel => channel.manual_job_posting_can_use).map(channel => channel.id).value()
    },
    autoJobPostingUsedChanelIds () {
      return _.chain(this.channelList).filter(channel => channel.auto_job_posting_can_use).map(channel => channel.id).value()
    }
  },
  created () {
  },
  methods: {
    getOptionListByStatus (channel) {
      const result = []
      const originStatus = channel.originStatus
      const newStatus = channel.newStatus
      if ([CHANNEL_OPERATION_ADD, CHANNEL_OPERATION_UPDATE, CHANNEL_OPERATION_HIDE].includes(newStatus)) {
        result.push({
          label: this.$t(`${this.i18nPrefix}.btn.channelDialog.cancel`),
          action: CHANNEL_OPERATION_CANCEL
        })
      } else if (originStatus === 'none') {
        if (_.includes(this.autoJobPostingUsedChanelIds, channel.id)) {
          result.push({
            label: this.$t(`${this.i18nPrefix}.btn.channelDialog.add`),
            action: CHANNEL_OPERATION_ADD
          })
        }
        if (_.includes(this.manualJobPostingUsedChanelIds, channel.id)) {
          result.push({
            label: this.$t(`${this.i18nPrefix}.btn.channelDialog.manualAdd`),
            action: CHANNEL_OPERATION_MANUAL_ADD
          })
        }
      } else if (originStatus === CHANNEL_OPERATION_PUBLISH) {
        if (channel.id !== DEFAULT_CHANNEL_ID) {
          if (channel.third_party_link) {
            result.push({
              label: this.$t(`${this.i18nPrefix}.btn.channelDialog.view`),
              action: CHANNEL_OPERATION_VIEW
            })
          }
          result.push({
            label: this.$t(`${this.i18nPrefix}.btn.channelDialog.update`),
            action: CHANNEL_OPERATION_UPDATE
          })
        }
        result.push({
          label: this.$t(`${this.i18nPrefix}.btn.channelDialog.${channel.id === DEFAULT_CHANNEL_ID ? 'hide' : 'unPublish'}`),
          action: CHANNEL_OPERATION_HIDE
        })
      } else {
        result.push({
          label: this.$t(`${this.i18nPrefix}.btn.channelDialog.unPublish`),
          action: CHANNEL_OPERATION_HIDE
        })
      }
      return result
    },
    handelChangeChannelPostStatus (option, channel) {
      if (_.includes([CHANNEL_OPERATION_MANUAL_ADD, CHANNEL_OPERATION_ADD], option)) {
        if (channel.has_count === false) {
          const count = channel.count || channelDefaultCountForLinkedin
          this.$message.warning(this.$t('admin.company.jobBoardPointDashboard.message.countsNotEnough', { count }))
          return
        }
        if (channel.has_points === false) {
          this.$message.warning(this.$t('admin.company.jobBoardPointDashboard.message.pointsNotEnough'))
          return
        }
      }
      if (option === CHANNEL_OPERATION_CANCEL) {
        channel.newStatus = ''
      } else if (option === CHANNEL_OPERATION_VIEW) {
        let thirdPartyLink = channel.third_party_link
        if (thirdPartyLink && !thirdPartyLink.startsWith('http')) {
          thirdPartyLink = 'http://' + thirdPartyLink
        }
        window.open(thirdPartyLink)
      } else if (option === CHANNEL_OPERATION_MANUAL_ADD) {
        this.$emit('manualAdd', channel)
      } else {
        channel.newStatus = option
      }
    },
    async handelPublishChannel () {
      if (this.isProcessing) {
        return
      }
      const channelOperation = {}
      _.forEach(this.channelList, (channel) => {
        if (channel.newStatus !== '' && channel.newStatus !== channel.originStatus) {
          channelOperation[channel.name] = channel.newStatus
          channel.isPending = true
        }
      })
      this.$emit('save', channelOperation)
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-container {

  border-bottom: 1px solid #DCDFE6;
  padding-bottom: 15px;

  .channel-list {
    display: flex;
    flex-wrap: wrap;
    min-height: 165px;
    margin-top: 12px;
    position: relative;

    .processing-message {
      padding-left: 15px;
      padding-bottom: 12px;
      width: 100%;

      &::before {
        content: '*';
        color: #f56c6c;
        margin-right: 5px;
        font-size: 14px;
        vertical-align: middle;
      }

      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        cursor: not-allowed;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }

    .list-item {
      width: 25%;
      padding-bottom: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;

      &.published {
        .channel-icon {
          border-color: #51BF82;

          .open-icon {
            color: #51BF82;
            &::before {
              content: "\e72a";
            }
          }
        }
      }

      &.delete {
        .channel-icon {
          border-color: #EA7F7F;

          .open-icon {
            color: #EA7F7F;
            &::before {
              content: "\e72b";
            }
          }
        }
      }

      &.add {
        .channel-icon {
          border-color: #F4A958;

          .open-icon {
            color: #F4A958;
            &::before {
              content: "\e72c";
            }
          }
        }
      }

      &.update {
        .channel-icon {
          border-color: #0896dd;

          .open-icon {
            color: #0896dd;
            &::before {
              content: "\e729";
            }
          }
        }
      }

      .channel-icon {
        position: relative;
        margin-bottom: 6px;
        border-color: #FFFFFF;

        > .iconfont {
          font-size: 74px;
          border-radius: 50%;
          padding: 2px;
          border: 2px solid #FFFFFF;
          border-color: inherit;
        }

        .open-icon {
          position: absolute;
          top: -6px;
          right: 0;
          width: 16px;
          height: 16px;
          z-index: 1;
          display: inline-block;
          font-family: iconfont!important;
          font-style: normal;
          font-size: 18px;
          font-variant: normal;
          text-transform: none;
          -webkit-font-smoothing: antialiased;

          &.none {
            display: none;
          }
        }
      }

      .dropdown-container {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }

      .operate-icon {
        position: absolute;
        right: -20px;
        top: 0px;
      }
    }
  }

  .tips {
    height: 18px;
    font-size: 14px;
    font-weight: 400;
    color: #303133;
    line-height: 18px;

    .service-email-address {
      color: #0096CC;
      cursor: pointer;
    }
  }

  .button-container {
    text-align: right;
    margin-top: 14px;

    .button {
      height: 30px;
      padding: 7px 22px;
      border-radius: 2px;
    }
  }

  .channel-loading {
    position: absolute;
  }

  .title-label {
    height: 23px;
    font-size: 17px;
    font-weight: 500;
    color: #303133;
    line-height: 23px;
  }
}
</style>

<style lang="scss">
.channel-operation-container {
  &.el-dropdown-menu  {
    padding: 0;

    .el-dropdown-menu__item {
      &:hover {
        background: #F0F0F0;
      }
    }
  }

  &.el-popper {
    .popper__arrow {
      display: none;
    }
  }
}
</style>
